/* eslint-disable */
import { WebStorageStateStore } from "oidc-client-ts";

// Persist the OIDC user in localStorage (instead of oidc-client-ts's default
// sessionStorage) so a newly-opened tab picks up an existing login on mount
// rather than starting logged out.
const userStore = new WebStorageStateStore({ store: window.localStorage });

export const oidcConfig_os = {
  authority: process.env.REACT_APP_OS_AUTHORITY,
  client_id: process.env.REACT_APP_OS_CLIENT_ID,
  client_secret: process.env.REACT_APP_OS_CLIENT_SECRET,
  redirect_uri: process.env.REACT_APP_OS_REDIRECT_ORIGIN,
  post_logout_redirect_uri: process.env.REACT_APP_OS_REDIRECT_ORIGIN,
  automaticSilentRenew: true,
  userStore,
  scope: "openid rights profile email modules"
};


export const oidcConfig_ms = {
  authority: process.env.REACT_APP_MS_AUTHORITY,
  client_id: process.env.REACT_APP_MS_CLIENT_ID,
 // client_secret: process.env.REACT_APP_MS_CLIENT_SECRET,
  redirect_uri: process.env.REACT_APP_MS_REDIRECT_ORIGIN,
  post_logout_redirect_uri: process.env.REACT_APP_MS_REDIRECT_ORIGIN,
  automaticSilentRenew: true,
  userStore,
  scope: "openid rights profile email modules"
};

export const oidcConfig_nkr = {
  authority: process.env.REACT_APP_MS_AUTHORITY,
  client_id: process.env.REACT_APP_MS_CLIENT_ID,
  //client_secret: process.env.REACT_APP_MS_CLIENT_SECRET,
  redirect_uri: process.env.REACT_APP_NKR_REDIRECT_ORIGIN,
  post_logout_redirect_uri: process.env.REACT_APP_NKR_REDIRECT_ORIGIN,
  automaticSilentRenew: true,
  userStore,
  scope: "openid rights profile email modules"
};
